module.exports = __webpack_public_path__ + "static/media/Dumplingfrito.37ea505c.jpg";